export function getColoursFromRoot(): Record<string, string> {
    const colours: Record<string, string> = {};
    
    Array.from(document.styleSheets).forEach((styleSheet) => {
        try {
            const rules = styleSheet.cssRules || [];
            Array.from(rules).forEach((rule) => {
                if (rule instanceof CSSStyleRule && rule.selectorText === ':root') {
                    const style = rule.style;
                    for (let i = 0; i < style.length; i++) {
                        const propertyName = style[i];
                        if (propertyName.startsWith('--colours-')) {
                            colours[propertyName.replace('--colours-', '')] = style.getPropertyValue(propertyName).trim();
                        }
                    }
                }
            });
        } catch (error) {
            // Catch CORS errors for external stylesheets
            console.error('Error accessing stylesheet:', error);
        }
    });

    return colours;
}